import { env, server } from 'config/environment'
import { TimeoutStore } from 'feature/timeout/TimeoutStore'
import { i18n } from 'i18n'
import { makeAutoObservable } from 'mobx'
import { Product } from 'type/Product'

const CAROUSEL_LIMIT = 20
const CAROUSEL_LIMIT_MIN = 3
const CAROUSEL_LIMIT_MAX = 100
const CAROUSEL_DELAY = 3000
const CAROUSEL_DELAY_MIN = 1000
const CAROUSEL_DELAY_MAX = 60000

// значение вне диапазона зажимаем, мусор игнорируем — стенд не должен падать из-за адреса
function carouselNumber(param: string | null, index: number, min: number, max: number, fallback: number): number {
  const raw = param?.split(',')[index]?.trim()
  if (!raw) return fallback
  const value = Number(raw)
  if (!Number.isFinite(value)) return fallback
  return Math.min(Math.max(Math.round(value), min), max)
}

export class WelcomeStore {
  private readonly product: Product
  private _ready: boolean = false
  private _width: number | null = null
  private _doc: string | null = null
  readonly timeout = new TimeoutStore(this.onClose.bind(this))

  constructor(product: Product) {
    this.product = product
    makeAutoObservable(this)
  }

  // стартовая с каруселью образов (WNDW-16): пока включается только параметром
  // ?carousel[=<количество карточек>[,<интервал прокрутки в мс>]]
  private get carouselParam(): string | null {
    if (server) return null
    return new URLSearchParams(location.search).get('carousel')
  }

  get carousel(): boolean {
    return this.carouselParam !== null
  }

  get carouselLimit(): number {
    return carouselNumber(this.carouselParam, 0, CAROUSEL_LIMIT_MIN, CAROUSEL_LIMIT_MAX, CAROUSEL_LIMIT)
  }

  get carouselDelay(): number {
    return carouselNumber(this.carouselParam, 1, CAROUSEL_DELAY_MIN, CAROUSEL_DELAY_MAX, CAROUSEL_DELAY)
  }

  get video(): string {
    const video = this.product.welcome?.video
    return video || 'https://opendata.dresscode.ai/salaris_2.mp4'
  }

  get policy(): string {
    const policy = this.product.welcome?.policy
    if (policy) return policy

    const atelier = env.domain === 'atelier'
    return atelier ? 'https://cdn.prod.website-files.com/6838e69fb452116b8e67ccca/698491ae03256260889c7af7_privacy-policy.pdf'
      : 'https://opendata.dresscode.ai/politika-konfidencialnosti.pdf'
  }

  get data(): string {
    const data = this.product.welcome?.data
    if (data) return data

    const atelier = env.domain === 'atelier'
    return atelier ? 'https://cdn.prod.website-files.com/6838e69fb452116b8e67ccca/698491aead396d0cbb0c9a24_user-acceptance-policy.pdf'
      : 'https://opendata.dresscode.ai/personal-data.pdf'
  }

  get button(): string {
    const button = this.product.welcome?.button
    return button || i18n('StartTryingOn').toUpperCase()
  }

  get color(): string | undefined {
    const color = this.product.welcome?.color
    return color || undefined
  }

  get background(): string | undefined {
    const background = this.product.welcome?.background
    return background || undefined
  }

  get ready(): boolean {
    return this._ready
  }

  set ready(ready: boolean) {
    this._ready = ready
  }

  get doc(): string | null {
    return this._doc
  }

  set doc(value: string | null) {
    this._doc = value
    if (value) this.timeout.start()
    else this.timeout.stop()
  }

  onClose() {
    this._doc = null
  }
}
